import { render } from "./AttrChips.vue?vue&type=template&id=5bdfb5a2&scoped=true"
import script from "./AttrChips.vue?vue&type=script&lang=js"
export * from "./AttrChips.vue?vue&type=script&lang=js"

import "./AttrChips.vue?vue&type=style&index=0&id=5bdfb5a2&scoped=true&lang=css"
import "./AttrChips.vue?vue&type=style&index=1&id=5bdfb5a2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdfb5a2"],['__file',"src/components/widgets/components_core/AttrChips.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bdfb5a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bdfb5a2', __exports__)) {
    api.reload('5bdfb5a2', __exports__)
  }
  
  module.hot.accept("./AttrChips.vue?vue&type=template&id=5bdfb5a2&scoped=true", () => {
    api.rerender('5bdfb5a2', render)
  })

}


export default __exports__